$ = require 'jquery'

Helpers = {}

Helpers.replace_currency = (currency) ->
  console.log 'replace_currency', currency
  currency = currency.replace /рб/, '<span class="ruble"></span>'
  currency = currency.replace /Eu/, 'у.е.'
  console.log 'replace_currency result', currency
  currency

Helpers.h1 = (text, css_class = '') ->
  Helpers.h1n(text, css_class)
#  '<h1 class="' + css_class + '">' + text + '</h1>'

Helpers.h1n = (text, css_class = '') ->
  $('<div class="row blue"><h1 class="' + css_class + '">' + text + '</h1></div>')

Helpers.h2 = (text, css_class = '') ->
  '<h2 class="' + css_class + '">' + text + '</h2>'

Helpers.row = (wrapper = true, css_class = '') ->
  $row = $ '<div></div>',
    class: 'row ' + css_class
  if wrapper
    $wrapper = $ '<div></div>',
      class: 'wrapper'
    $row.append $wrapper
  return $row

Helpers.rowN = (wrapper = true, css_class = '') ->
  $row = $ '<div></div>',
    class: 'row ' + css_class
  if wrapper
    $wrapper = $ '<div></div>',
      class: 'wrapper'
    $row.append $wrapper
    return [$row, $wrapper]
  else
    return $row

#Helpers.rowQ = ->
#  $row = $ '<div></div>',
#    class: 'row'
#  $wrapper = $ '<div></div>',
#    class: 'wrapper'
#  $row.append $wrapper
#  return [$row, $wrapper]

Helpers.column = (css_class = '') ->
  $('<div class="column ' + css_class + '"></div>')

Helpers.columnsLR = (css_class = '') ->
  $columns = $ '<div/>',
    class: 'columns ' + css_class
  $left = $ '<div/>',
    class: 'column left'
  $right = $ '<div/>',
    class: 'column right'
  $columns.append $left
  $columns.append $right
  [$columns, $left, $right]

Helpers.block = (title, css_class = '') ->
  $('<div class="block ' + css_class + '"><h3>' + title + '</h3><div class="wrapper"></div></div>')

Helpers.blockN = (title, css_class = '') ->
  $block = $ '<div></div>',
    class: 'block ' + css_class
  $h3 = $ '<h3>' + title + '</h3>'
  $wrapper = $ '<div></div>',
    class: 'wrapper'
  $block.append $h3
  $block.append $wrapper
  return [$block, $wrapper]

Helpers.getUrlVariable = (name) ->
  vars = {}
  vs = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&')
  for v in vs
    kv = v.split('=')
    vars[kv[0]] = kv[1]
  vars[name]

module.exports = Helpers